var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Typography, styled } from '@mui/material';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CurrencyCode, StatusPermission } from '../../../enum';
import { useUserPermissionsAPI } from '../../app/selectors';
import { Autocomplete, FormField } from '../../common';
import { OTHER_CURRENCY_ID, currencyAutocompleteListboxProps, useRollupAvailableCurrencies } from '../../hooks';
import { AddCustomCurrencyDialog } from '../../orgConfigWizard/financials/AddCustomCurrencyDialog';
import { BasePanel } from '../common/basePanel';
import { WizardContext } from '../context';
import { useRefreshQueueData } from '../queue/selectors';
import { QueueStatusType } from '../queue/types';
import { useEffectiveCapacityPermission, useEffectivePlanPermission, useIsPlanLocked, usePlanAPI, usePlanFxRatesAPI, useQueueLocations, useSavePlanFxRatesAPI } from '../selectors';
import { SupportStaffTable } from '../supportStaff/locationRoleTable';
import { useClearRoleAPI, useCopyRoleAPI } from '../supportStaff/selectors';
var StyledContainer = styled(Grid)(function (_a) {
  var theme = _a.theme;
  return {
    width: theme.typography.pxToRem(340)
  };
});
export var CurrencySelect = function () {
  var _a, _b, _c;
  var t = useTranslation('wizard', {
    keyPrefix: 'financial'
  }).t;
  var tOrgConfig = useTranslation('orgConfig', {
    keyPrefix: 'financials'
  }).t;
  var financialPermission = useUserPermissionsAPI().financialPermission;
  var capacityPermission = useEffectiveCapacityPermission();
  var effectiveFinancialPermission = useEffectivePlanPermission(financialPermission);
  var _d = useFormContext(),
    control = _d.control,
    setValue = _d.setValue;
  var planData = usePlanAPI()[0];
  var rollupCurrency = ((_b = (_a = planData.data) === null || _a === void 0 ? void 0 : _a.currency) !== null && _b !== void 0 ? _b : 'USD').toUpperCase();
  var _e = usePlanFxRatesAPI(),
    fxRatesData = _e[0],
    fetchFxRates = _e[1];
  var _f = useSavePlanFxRatesAPI(),
    saveFxRates = _f[1];
  useEffect(function () {
    fetchFxRates();
  }, [fetchFxRates]);
  var knownRateCodes = useMemo(function () {
    var _a, _b;
    return ((_b = (_a = fxRatesData.data) === null || _a === void 0 ? void 0 : _a.rates) !== null && _b !== void 0 ? _b : []).map(function (r) {
      return r.currencyCode;
    });
  }, [(_c = fxRatesData.data) === null || _c === void 0 ? void 0 : _c.rates]);
  // A just-added custom code isn't in knownRateCodes until the save round-trips through
  // findPlanFxRates (which only reports currencies a saved queue location actually uses) -- keep
  // it supported locally in the meantime, same pattern as the org config financials step.
  var _g = useState([]),
    pendingCustomCodes = _g[0],
    setPendingCustomCodes = _g[1];
  var supportedCodes = useMemo(function () {
    return Array.from(new Set(__spreadArray(__spreadArray([], knownRateCodes, true), pendingCustomCodes, true)));
  }, [knownRateCodes, pendingCustomCodes]);
  var _h = useRollupAvailableCurrencies(rollupCurrency, {
      extraSupportedCodes: supportedCodes
    }),
    optionsForValue = _h.optionsForValue,
    isSupported = _h.isSupported,
    requesting = _h.requesting;
  var currentCurrency = useWatch({
    control: control,
    name: 'sourceCurrencyCode'
  });
  var currencyOptions = useMemo(function () {
    return __spreadArray(__spreadArray([], optionsForValue(currentCurrency), true), [{
      id: OTHER_CURRENCY_ID,
      name: String(tOrgConfig('location.otherCurrency', {
        defaultValue: 'Other...'
      })),
      symbol: ''
    }], false);
  }, [optionsForValue, currentCurrency, tOrgConfig]);
  var unsupported = Boolean(currentCurrency && !isSupported(currentCurrency));
  var _j = useState(false),
    customCurrencyOpen = _j[0],
    setCustomCurrencyOpen = _j[1];
  var handleAddCustomCurrency = useCallback(function (_a) {
    var currencyCode = _a.currencyCode,
      corporateOverrideRate = _a.corporateOverrideRate;
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_b) {
        setPendingCustomCodes(function (prev) {
          return prev.includes(currencyCode) ? prev : __spreadArray(__spreadArray([], prev, true), [currencyCode], false);
        });
        saveFxRates({
          rates: [{
            currencyCode: currencyCode,
            corporateOverrideRate: corporateOverrideRate
          }]
        });
        fetchFxRates();
        setValue('sourceCurrencyCode', currencyCode, {
          shouldDirty: true,
          shouldValidate: true
        });
        return [2 /*return*/];
      });
    });
  }, [saveFxRates, fetchFxRates, setValue]);
  var isPlanLocked = useIsPlanLocked();
  var disabled = capacityPermission !== StatusPermission.Edit || effectiveFinancialPermission !== StatusPermission.Edit || isPlanLocked || requesting;
  return _jsxs(StyledContainer, __assign({
    container: true,
    alignItems: "center",
    columnSpacing: 2
  }, {
    children: [_jsx(Grid, __assign({
      item: true,
      xs: 4.5,
      textAlign: "right"
    }, {
      children: _jsx(Typography, __assign({
        color: unsupported ? 'error' : undefined
      }, {
        children: t('selectCurrency')
      }))
    })), _jsx(Grid, __assign({
      item: true,
      xs: 7.5
    }, {
      children: _jsx(FormField, __assign({
        required: true,
        name: "sourceCurrencyCode",
        control: control,
        defaultValue: CurrencyCode.Dollar
      }, {
        children: _jsx(Autocomplete, {
          disabled: disabled,
          options: currencyOptions,
          getOptionLabel: function (o) {
            return o.name;
          },
          getOptionValue: function (o) {
            return o.id;
          },
          isOptionEqualToValue: function (o, v) {
            var _a;
            return o.id === ((_a = v === null || v === void 0 ? void 0 : v.id) !== null && _a !== void 0 ? _a : v);
          },
          ListboxProps: currencyAutocompleteListboxProps,
          onChange: function (v) {
            if (v === OTHER_CURRENCY_ID) {
              setCustomCurrencyOpen(true);
              return false;
            }
          },
          error: unsupported,
          helperText: unsupported ? t('unsupportedCurrency', {
            defaultValue: '{{currency}} is not supported for plan currency {{rollup}}.',
            currency: currentCurrency,
            rollup: rollupCurrency
          }) : undefined
        })
      }))
    })), _jsx(AddCustomCurrencyDialog, {
      open: customCurrencyOpen,
      rollupCurrency: rollupCurrency,
      existingCodes: currencyOptions.map(function (o) {
        return o.id;
      }),
      onClose: function () {
        return setCustomCurrencyOpen(false);
      },
      onSave: handleAddCustomCurrency
    })]
  }));
};
export var StaffSalaries = function () {
  var t = useTranslation(['wizard', 'translation']).t;
  var refreshData = useRefreshQueueData();
  var financialPermission = useUserPermissionsAPI().financialPermission;
  var effectiveFinancialPermission = useEffectivePlanPermission(financialPermission);
  var _a = useCopyRoleAPI(true),
    copyRoleData = _a[0],
    copyRole = _a[1],
    clearCopyRoleData = _a[2];
  var _b = useClearRoleAPI(true),
    clearRoleData = _b[0],
    clearRole = _b[1],
    cleanClearRoleData = _b[2];
  var locations = useQueueLocations();
  var handleSaveWithoutValidation = useContext(WizardContext).handleSaveWithoutValidation;
  var isDirty = useFormContext().formState.isDirty;
  useEffect(function () {
    if (clearRoleData.data || copyRoleData.data) {
      refreshData();
    }
    return function () {
      cleanClearRoleData();
      clearCopyRoleData();
    };
  }, [cleanClearRoleData, clearCopyRoleData, clearRoleData.data, copyRoleData.data, refreshData]);
  var handleClear = function () {
    if (isDirty && handleSaveWithoutValidation) {
      handleSaveWithoutValidation('submit', function () {
        return clearRole();
      });
      return;
    }
    clearRole();
  };
  var handleCopy = function (source) {
    if (isDirty && handleSaveWithoutValidation) {
      handleSaveWithoutValidation('submit', function () {
        return copyRole(source);
      });
      return;
    }
    copyRole(source);
  };
  return _jsx(BasePanel, __assign({
    title: t('financial.staffSalaries'),
    statusType: QueueStatusType.Salary,
    onClear: handleClear,
    onCopy: handleCopy,
    errors: [clearRoleData.error, copyRoleData.error],
    requesting: !!clearRoleData.requesting || !!copyRoleData.requesting,
    rightContent: locations.length === 0 ? _jsx(CurrencySelect, {}) : undefined,
    permission: effectiveFinancialPermission === StatusPermission.Edit
  }, {
    children: _jsx(SupportStaffTable, {
      disableSupportStaff: true
    })
  }));
};